import { PERSONAL_REPRESENTATIVE_ROLES_REQUIRING_CHECKS } from '../constants'

export const cannotBePrimaryExecutorOrAdministrator = (
  personalRepresentativeRole: string
) => {
  if (!personalRepresentativeRole) return false
  return !PERSONAL_REPRESENTATIVE_ROLES_REQUIRING_CHECKS.includes(
    personalRepresentativeRole
  )
}
